'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-hair-mullet';
var width = 448;
var height = 512;
var aliases = ["business-front","party-back","trian-balbot"];
var unicode = 'e45c';
var svgPathData = ['M144 112l0 32c0 44.2 35.8 80 80 80s80-35.8 80-80l0-32-17.9 0c-27.5 0-52-17.6-60.7-43.8l-1.4-4.2-1.4 4.2c-8.7 26.1-33.2 43.8-60.7 43.8L144 112z', 'M144 144l0-32 17.9 0c27.5 0 52-17.6 60.7-43.8l1.4-4.2 1.4 4.2c8.7 26.1 33.2 43.8 60.7 43.8l17.9 0 0 32c0 44.2-35.8 80-80 80s-80-35.8-80-80zm208 0l0-32 0-1.4c9.3-3.3 16-12.2 16-22.6 0-13.3-10.7-24-24-24-.9 0-1.8 .1-2.7 .2-17.9-37.9-56.6-64.2-101.3-64.2L208 0c-44.7 0-83.3 26.2-101.3 64.2-.9-.1-1.8-.2-2.7-.2-13.3 0-24 10.7-24 24 0 10.5 6.7 19.3 16 22.6l0 1.4 0 32c0 24.7 7 47.8 19.1 67.3l-15 22.5c-2.7 4-4.1 8.8-4.1 13.6 0 13.6 11 24.6 24.6 24.6l206.9 0c13.6 0 24.6-11 24.6-24.6 0-4.8-1.4-9.6-4.1-13.6l-15-22.5C345 191.8 352 168.7 352 144zM180.6 320C89.7 320 16 393.7 16 484.6 16 499.7 28.3 512 43.4 512l361.1 0c15.1 0 27.4-12.3 27.4-27.4 0-90.9-73.7-164.6-164.6-164.6l-86.9 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserHairMullet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;